import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header pt-5" }
const _hoisted_2 = { class: "card-title d-flex flex-column" }
const _hoisted_3 = { class: "fs-2hx fw-bold text-white me-2 lh-1 ls-n2" }
const _hoisted_4 = { class: "text-white opacity-75 pt-1 fw-semibold fs-6" }
const _hoisted_5 = { class: "card-body d-flex align-items-end pt-0" }
const _hoisted_6 = { class: "d-flex align-items-center flex-column mt-3 w-100" }
const _hoisted_7 = { class: "d-flex justify-content-between fw-bold fs-6 text-white opacity-50 w-100 mt-auto mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_9 = { class: "h-8px mx-3 w-100 bg-white bg-opacity-50 rounded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end", _ctx.widgetClasses]),
    style: {"background-color":"rgb(241, 65, 108)","background-image":"url(/media/patterns/lineas-bg.jpg)","background-position":"bottom","background-size":"cover"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.amount), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_ctx.subTitle), 1),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "bg-white rounded h-8px",
            role: "progressbar",
            "aria-valuenow": "50",
            "aria-valuemin": "0",
            "aria-valuemax": "100",
            style: _normalizeStyle(`width: ${_ctx.amount}%;`)
          }, null, 4)
        ])
      ])
    ])
  ], 2))
}